module.exports = "pegasus/assets/hexagon-google.png";